<template>
    <div class="page-container" :class="{ collapsed: !$store.getters.sidebarOpened }">
        <div class="data-container center-area" style="width: 100%">
            <div class="tool-box">
                <el-button type="primary" :icon="Refresh" @click="resetQueryForm">刷新</el-button>
                <el-button type="primary" :icon="Plus" plain @click="onAddClick()">添加</el-button>
            </div>
            <el-form class="search-form" ref="search_form" :inline="true" :model="search_params" label-position="top">
                <el-form-item label="名称" prop="name">
                    <el-input style="width: 165px" v-model="search_params.name" clearable placeholder="请输入名称" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" plain @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="table_data" v-loading="tableLoading">
                <el-table-column label="户名姓名" prop="name" align="center"></el-table-column>
                <el-table-column label="联系方式" prop="phone" align="center"></el-table-column>
                <el-table-column label="账户" width="200px" prop="account" align="center"></el-table-column>
                <el-table-column label="绑定房间" prop="room_list" align="center" show-overflow-tooltip>
                    <template #default="{ row }">
                        <span v-for="room in row.room_list" :key="room.room_id">{{ room.room_name + '  ' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="350">
                    <template #default="{ row }">
                        <el-button type="primary" link :icon="View" @click="onShowClick(row)">详情</el-button>
                        <el-button type="primary" link :icon="Edit" @click="onEditClick(row)">编辑</el-button>
                        <el-button type="primary" :icon="Delete" link @click="onRemoveClick(row)">删除</el-button>
                        <el-button type="primary" :icon="Plus" link @click="onBindRoomClick(row)">绑定房间</el-button>
                        <el-button type="primary" :icon="Plus" link @click="openReset(row)">充值</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination
                v-if="table_data.length > 0"
                :current-page="page_params.page"
                :page-size="page_params.page_size"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
            <add-forms-dialog
                v-if="addformDialogVisible"
                v-model="addformDialogVisible"
                :isForm="isForm"
                :formId="selectModelId"
                @updateForm="getTableData"
            />
            <bind-room-dialog
                v-model="dialogVisible"
                :treeData="roomTreeData"
                :boundRoomIds="alreadyBoundIds"
                @confirm="handleBindConfirm"
            />

            <ResetAmountDialog ref="resetRef" @success="getTableData" />
        </div>
    </div>
</template>

<script setup>
import { onMounted, reactive, ref, watch } from 'vue'
import { Delete, Download, Edit, Plus, Refresh, Search, Upload, View } from '@element-plus/icons'
import { delHousehold, getHouseholdLists, bindRooms } from '@/api/household.js'
import { getOptionTree } from '@/api/room.js'
import addFormsDialog from './components/addForms.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import Pagination from '@/components/Pagination/index.vue'
import bindRoomDialog from './components/bindRoom.vue'
import ResetAmountDialog from './components/ResetAmountDialog.vue'
// 重置
const search_form = ref(null)
const resetQueryForm = () => {
    search_form.value.resetFields()
    getTableData()
}
// 数据源
const search_params = reactive({
    name: ''
})

const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)

// 获取列表数据
async function getTableData() {
    tableLoading.value = true
    const params = { ...search_params, ...page_params }
    try {
        const { lists, total: total_count } = await getHouseholdLists(params)
        table_data.value = lists
        total.value = total_count
        tableLoading.value = false
    } catch (err) {
        console.log(err)
        tableLoading.value = false
    }
}

// 分页相关
const page_params = reactive({
    page: 1,
    page_size: 10
})
const handleSizeChange = (currentSize) => {
    page_params.page_size = currentSize
    page_params.page = 1
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    page_params.page = currentPage
    getTableData()
}

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectModelId = ref('') // 点中的模块id
const detail_data = ref({})
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) selectModelId.value = ''
})

// 查看
const onShowClick = (row) => {
    isForm.value = false
    selectModelId.value = row.id
    detail_data.value = row
    addformDialogVisible.value = true
}
// 编辑
const onEditClick = (row) => {
    isForm.value = true
    selectModelId.value = row.id
    detail_data.value = row
    addformDialogVisible.value = true
}
const addformDialogVisible = ref(false)
// 添加
const onAddClick = () => {
    selectModelId.value = ''
    addformDialogVisible.value = true
    isForm.value = true
}

// 删除
function onRemoveClick(row) {
    ElMessageBox.confirm('是否确认删除用户【' + row.name + '】？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        delHousehold(row.id).then(() => {
            ElMessage.success('删除成功')
            getTableData()
        })
    })
}

const dialogVisible = ref(false)
const alreadyBoundIds = ref([])
const roomTreeData = ref([])
// 绑定房间
const onBindRoomClick = (row) => {
    detail_data.value = row
    alreadyBoundIds.value = row.room_list.map((item) => item.room_id)
    dialogVisible.value = true
}
const handleBindConfirm = async (roomIds) => {
    console.log('选中的房间id数组：', roomIds)
    // 调用接口绑定
    await bindRooms({ household_id: detail_data.value.id, room_list: roomIds })
    ElMessage.success('绑定成功')
    dialogVisible.value = false
    getTableData()
}
const resetRef = ref(null)
// 打开重置弹窗
function openReset(row) {
    resetRef.value.open(row)
}
// 切换到前台时候执行
onMounted(async () => {
    roomTreeData.value = await getOptionTree()
    getTableData()
})
</script>

<style scoped></style>
